<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<section class="lease-endow" [hidden]="spinner">
  <header *ngIf="leaseEndowType !== 'empty'" class="lease-endow--header">
    <div class="lease-endow--header__container">
      <h5 class="lease-endow--header__title">
        {{ (requestCarType ? ('new' + requestCarType) : 'newRequestLeasEndowTitle') | i18next }}
      </h5>
      <div #stepperHeader></div>
    </div>
  </header>
  <div [style]="'width: 100%; display: flex; justify-content: center;'">
    <div class="lease-endow--body">
      <main class="main" *ngIf="leaseEndowType === 'empty'">
        <h2 class="main--title" style="margin-top: 40px; margin-bottom: 20px">
          {{ (requestCarType ? ('new' + requestCarType) : 'newRequestLeasEndowTitle') | i18next }}
        </h2>
        <h4 class="main--title" style="margin-bottom: 40px">
          {{ 'leaseEndowSubtitle' | i18next }}
        </h4>
        <div class="main--container">
          <div class="main--container__flex">
            <div class="main--container__item">
              <div class="main--container__item--info">
                <p class="main--container__title stock">
                  {{ 'stockVehicle' | i18next }}
                </p>
                <button
                  class="main--container__btn"
                  (click)="setLeaseEndowSteps('stock')"
                >
                  {{ 'btnSelect' | i18next | uppercase }}
                </button>
              </div>
              <aside class="main--container__aside">
                <div class="stock-vehicle-container"></div>
              </aside>
            </div>
            <div class="main--container__item">
              <div class="main--container__item--info">
                <p class="main--container__title vehicle">
                  {{ 'leaseEndowConfig' | i18next }}
                </p>
                <button
                  class="main--container__btn"
                  (click)="setLeaseEndowSteps('config')"
                >
                  {{ 'btnSelect' | i18next | uppercase }}
                </button>
              </div>
              <aside class="main--container__aside">
                <div class="configure-vehicle-container"></div>
              </aside>
            </div>
            <span *ngIf="isPhone" style="max-width: 400px;">{{ 'notPhoneMessage' | i18next }}</span>
            <span *ngIf="isPhone" style="max-width: 400px;">{{ 'notPhoneMessageSubtitle' | i18next }}</span>
          </div>
        </div>
        <button
          class="lease-endow--header__exit"
          [routerLink]="landing2 ? ['/landing-leasing'] : ['/menu']"
          style="margin-top: 40px"
        >
          <img
            class="lease-endow--header__exit--icon"
            src="../../../assets/icons/arrow_back_black.svg"
            alt="Salir"
          />
          <p class="lease-endow--header__exit--text text-uppercase">
            {{ 'btnReturn' | i18next }}
          </p>
        </button>
      </main>
    </div>
  </div>
  <app-stepper
    [leaseEndowType]="leaseEndowType"
    [user]="user"
    [requestType]="requestType"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
    (onCancel)="initial()"
  ></app-stepper>
</section>
